import script from "./Icon.vue?vue&type=script&setup=true&lang=js"
export * from "./Icon.vue?vue&type=script&setup=true&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=e6ff3e74&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ff3e74"]])

export default __exports__